import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderList = _resolveComponent("OrderList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'has-background-black': _ctx.isDark })
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statusFilter) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateStatusFilter && _ctx.updateStatusFilter(...args))),
      name: "statusFilter",
      class: "form-control"
    }, null, 544), [
      [_vModelText, _ctx.statusFilter]
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["button is-light", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshTickets && _ctx.refreshTickets(...args)))
    }, " Refresh ", 2),
    (_ctx.tickets)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_OrderList, {
                  listings: _ctx.tickets,
                  isDark: _ctx.isDark
                }, null, 8, ["listings", "isDark"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.tickets==null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No orders or user not authorized! "))
      : _createCommentVNode("", true)
  ], 2))
}